import { Box, IconButton } from "@mui/material";
import React, { ReactNode } from "react";
import { Text } from "../Typography";
import { vars } from "../Variables";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Chips } from "../Chips";
import useSmartPhone from "../../hooks/useSmartPhone";

const { primaryFont } = vars

type Data = {
  heading: string;
  primaryText?: string;
  secondaryText?: string;
}

type chipObject = {
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
  label: string;
}

interface IPrimaryList {
  isSecondary?: boolean;
  icon?: ReactNode;
  data?: Data;
  additionalText?: string;
  onClickEdit?: () => void;
  onClickDelete?: () => void;
  chip?: chipObject;
}

export const PrimaryList: React.FC<IPrimaryList> = ({ isSecondary, icon, data, additionalText, onClickEdit, onClickDelete, chip }) => {

  const isSmartPhone = useSmartPhone();

  const classes = {
    icon: {
      background: '#EBF4FF',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      justifyContent: 'center',
      '& img': {
        maxWidth: '100%',
        objectFit: 'contain',
        maxHeight: '100%',
      }
    },

    round: {
      borderRadius: '50%',
      width: isSmartPhone ? '100%' : '72px',
      height: '72px',
    },

    rectangle: {
      width: isSmartPhone ? '100%' : '144px',
      height: '83px',
      borderRadius: '8px'
    }
  }

  const iconClass = isSecondary ? classes.rectangle : classes.round;

  return (
    <Box
      display='flex'
      columnGap={3}
      sx={{
        py: 2,
        gap: {
          xs: 2,
          lg: 0
        },
        alignItems: {
          xs: 'inherit',
          lg: 'flex-start'
        },
        flexDirection: {
          xs: 'column',
          lg: 'row'
        },
        '&:first-of-type': {
          paddingTop: 0
        },
        '&:last-of-type': {
          paddingBottom: 0,

          '& > div:last-of-type': {
            '&:after': {
              display: 'none'
            }
          },
        },
      }}
    >
      <Box sx={{ ...classes.icon, ...iconClass }}>
        {icon}
      </Box>
      <Box
        position='relative'
        flex={1}
        sx={{
          '&:after': {
            content: '""',
            position: 'absolute',
            bottom: -16,
            height: '1px',
            width: '100%',
            background: '#DADADA',

          }
        }}
      >
        <Box
          display='flex'
          alignItems='center'
          mb={isSecondary ? 1.5 : 0.5}
        >
          <Text mr={1} sx={{ 
            color: '#1D183E', fontFamily: primaryFont, flex: 1 
          }}>{data?.heading}</Text>
          {onClickEdit && (
            <IconButton onClick={onClickEdit}>
              <EditIcon sx={{fontSize: 18}} />
            </IconButton>
          )}

          {onClickDelete && (
            <IconButton onClick={onClickDelete}>
              <DeleteOutlineIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}

          {chip && <Chips sx={{ height: '30px', px: 1, ml: 1}} size="small" color={chip?.color || "success"} label={chip?.label} />}

        </Box>
        <Text variant="h4" sx={{ color: '#787689', fontWeight: 'normal', lineHeight: '22px' }}>{data?.primaryText}</Text>
        <Text variant="h4" sx={{ color: '#787689', fontWeight: 'normal', lineHeight: '22px' }}>{data?.secondaryText}</Text>

        {additionalText && (
          <Box mt={1}>
            <Text variant="h4" sx={{ color: '#787689', fontWeight: 'normal', lineHeight: '22px' }}>{additionalText}</Text>
          </Box>
        )}
      </Box>

    </Box>
  )
}